import type { AppLocale } from './index';
import { en } from './locales/parent/en';
import { ms } from './locales/parent/ms';

export const parentResources = { en, ms };

// Bump when any key in CONSENT_KEYS changes; the API only accepts the current version.
export const PARENT_CONSENT_VERSION = 'v1';
export const PARENT_DATA_SCOPE_VERSION = 'v1';

const CONSENT_KEYS = [
  'consentTitle',
  'consentIntro',
  'consentCollectsTitle',
  'consentCollectsIntro',
  'consentCollectsList',
  'consentCollectsUse',
  'consentSeeTitle',
  'consentSeeBody',
  'consentCheckbox',
] as const;

/** The consent wording a parent agrees to, as raw message templates. */
export function parentConsentWording(language: AppLocale): string {
  return CONSENT_KEYS.map((key) => parentResources[language].children[key]).join('\n');
}
